/** @format */
import axios from "axios";
import { api } from "../revampCRUD/axios.config";

axios.defaults.baseURL = api?.apiUrl;

export const eventCaptureApi = () => {
	return api?.apiUrl;
	
};

export default axios;
